import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'signatureFilter',
  standalone: true
})
export class SignatureFilterPipe implements PipeTransform {
    // transform(items: any[], filterVAlue:string): any {
    //     return items.filter(i => i.name.includes(filterVAlue))
    //   }
    transform(items: any[], filterValue: string): any {
        if (!items || !filterValue || filterValue == null) {
            return items;
        }

        return items.filter(item => (item.signature.toLowerCase()).indexOf(filterValue.toLowerCase()) !== -1);
    }
}
